import { supabase } from '../lib/supabase';

// App-level configuration keys read by the maintenance + force-update gates.
// Backed by the existing public.app_settings table; values are jsonb but every
// key here unwraps to a string or boolean.
const KEYS = [
  'maintenance_mode',
  'maintenance_message',
  'min_ios_app_version',
  'force_update_message',
];

const DEFAULTS = {
  maintenance_mode: false,
  maintenance_message: "We'll be back shortly. Thanks for your patience.",
  min_ios_app_version: '0.0.0',
  force_update_message: 'A new version of TeeSync is available. Please update to continue.',
};

const unwrap = (value, fallback) => {
  if (value === null || value === undefined) return fallback;
  return value;
};

// Single fetch - anyone (anon + authenticated) can SELECT from app_settings
// per existing RLS, so this works even before the user is logged in.
export const getAppConfig = async () => {
  try {
    const { data, error } = await supabase
      .from('app_settings')
      .select('key, value')
      .in('key', KEYS);

    if (error) {
      console.warn('[appConfig] fetch failed:', error);
      return { ...DEFAULTS };
    }

    const out = { ...DEFAULTS };
    (data || []).forEach((row) => {
      out[row.key] = unwrap(row.value, DEFAULTS[row.key]);
    });
    return out;
  } catch (err) {
    console.warn('[appConfig] exception:', err);
    return { ...DEFAULTS };
  }
};

// Super-admin-only via RPC. Throws on permission denial.
export const setAppConfig = async (key, value) => {
  const { data, error } = await supabase.rpc('set_app_setting', {
    p_key: key,
    p_value: value,
  });
  if (error) throw error;
  return data;
};
